<template>
    <div class="collate-form">
        <!-- 公共表单部分 -->
        <!-- 输入姓名+分组 -->
        <div class="collate-form-box">
            <label class="collate-form-label cf-label-two">姓 名</label>
            <input class="collate-form-input" type="text" maxlength="15" placeholder="输入称呼" @input='changeName' @blur='blurInputName' v-model="formData.f_name" autofocus>
            <div class="collate-form-choose cf-pos-right" @click="chooseGroup">
                <span v-if="choosedGroup.id > 0" class="cf-icon-text">{{choosedGroup.f_name.slice(0, 6)}}</span>
                <span v-else class="cf-icon-text">选择分组</span>
                <i class="cf-icon-right iconfont icon-xiangyou"></i>
            </div>
        </div>
        <!-- 选择性别 -->
        <div class="collate-form-box">
            <label class="collate-form-label cf-label-two">性 别</label>
            <span class="collate-form-sex" @click="selectSex(0)">
                <i class="iconbg icon-sex icon-male"></i>
                <i class="cf-icon-sex iconfont" :class="{'icon-selected' : formData.sex == 0, 'icon-unselected' : formData.sex == 1}"></i>
            </span>
            <span class="collate-form-sex" @click="selectSex(1)">
                <i class="iconbg icon-sex icon-female"></i>
                <i class="cf-icon-sex iconfont" :class="{'icon-selected' : formData.sex == 1, 'icon-unselected' : formData.sex == 0}"></i>
            </span>
            <div class="collate-form-choose cf-pos-right" @click="chooseLabel">
                <span v-if="selectedLabelString != ''" class="cf-icon-text">{{selectedLabelString.slice(0, 5)}}</span>
                <span v-else class="cf-icon-text">标签备注</span>
                <i class="cf-icon-right iconfont icon-xiangyou"></i>
            </div>
        </div>
        <div class="collate-form-box" @click="selectArea">
            <label class="collate-form-label">出生地</label>
            <div class="collate-form-note">
                <div class="collate-form-note-two" v-if="selectedArea.length == 0">
                    <p>非必选</p>
                    <p>选择后将根据出生地时差计算出真太阳时</p>
                </div>
                <div class="collate-form-note-two" v-else>
                    <p v-for="(area, key) in selectedArea" :class="{'collate-form-note-area' : (key == 0)}" v-bind:key="key">{{area}}</p>
                </div>
                <i class="icon-right-arrow"></i>
            </div>
            <div class="cf-pos-right"><i class="cf-icon-right iconfont icon-xiangyou"></i></div>
        </div>
        <div class="collate-form-box" @click="selectBirthday">
            <label class="collate-form-label cf-label-two">生 日</label>
            <div class="collate-form-note">
                <div v-if="selectedBirthday.length == 0">
                    <p>点击输入出生日期</p>
                    <i class="icon-right-arrow"></i>
                </div>
                <div class="collate-form-note-two" v-else>
                    <p v-for="(birth, key) in selectedBirthday" :class="{'collate-form-note-area' : (key == 0)}" v-bind:key="key">{{birth}}</p>
                </div>
            </div>
            <div class="cf-pos-right"><i class="cf-icon-right iconfont icon-xiangyou"></i></div>
        </div>
        <!-- 编辑页:区分早晚子时 -->
        <div v-if="parentNode.name == 'EditDetail'">
            <div class="collate-form-box">
                <label class="collate-form-label cf-label-two">分早晚子时</label>
                <div class="collate-form-note">
                    <span class="collate-form-span">24点作为一天点开始</span>
                    <van-switch class="collate-form-switch" v-model="choosedZWZ" @change="changeZWZ" size="22px" active-color="#0d9700" inactive-color="#eee" />
                </div>
            </div>
            <div class="collate-form-box">
                <label class="collate-form-label cf-label-two">不分早晚子时</label>
                <div class="collate-form-note">
                    <span class="collate-form-span">23点作为一天点开始</span>
                    <van-switch class="collate-form-switch" v-model="choosedNZWZ" @change="changeNZWZ" size="22px" active-color="#0d9700" inactive-color="#eee" />
                </div>
            </div>
        </div>
        <!-- 起盘页:提交按钮 -->
        <div v-else-if="parentNode.name == 'Collate'" class="collate-form-btn dsp-flex">
            <div class="collate-form-btn-side">
                <div class="button-report" v-bind:class="{'button-report-org': !aiButtonClickedStatus}" @click="clickStart('report')">
                    <p>智能</p>
                    <p>测算</p>
                </div>
            </div>
            <div class="collate-form-btn-main">
                <button class="button-green" @click="clickStart('collate')">起  盘</button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'CollateForm',
    props: ['parentNode', 'chooseGroupFunc', 'personData', 'chooseLabelFunc'],
    computed: {
        aiButtonClickedStatus() {
            return this.$store.state.reminder.aiButtonClickedStatus;
        },
        choosedGroup() {
            return this.$store.state.group.choosedGroup;
        },
        selectedLabelString() {
            return this.$store.state.label.selectedLabelString;
        },
        formData() {
            return this.$store.state.collate.formData;
        },
        selectedArea() {
            return this.$store.state.collate.selectedArea;
        },
        selectedBirthday() {
            return this.$store.state.collate.selectedBirthday;
        }
    },
    data(){
        return {
            choosedZWZ: false,
            choosedNZWZ: false
        }
    },
    mounted: function() {
        // 编辑命盘页:设置当前早晚子时状态
        if(this.personData){
            this.choosedZWZ = this.personData.zwzs == 1 ? true : false;
            this.choosedNZWZ = this.personData.zwzs == 0 ? true : false;
        }
    },
    methods:{
        chooseGroup() {
            if(this.chooseGroupFunc && typeof(this.chooseGroupFunc) == 'function'){
                this.chooseGroupFunc();
            }
        },
        chooseLabel() {
            if(this.chooseLabelFunc && typeof(this.chooseLabelFunc) == 'function') {
                this.chooseLabelFunc();
            }
        },
        selectSex(index) {
            this.$store.state.collate.formData.sex = index;

            // 编辑页面要触发编辑页的命盘信息的更改
            if(this.parentNode.name == 'EditDetail'){
                this.$store.dispatch('edit/updateEditDetail', 'sex');
            }
        },
        selectArea() {
            this.$store.state.collate.showArea = true;
        },
        selectBirthday() {
            this.$store.state.collate.showBirthday = true;
        },
        clickStart(type) {
            if(type == 'collate') {
                window._czc.push(["_trackEvent", "起盘模块", "起盘", "点击起盘"]);
            }else if(type == 'report') {
                window._czc.push(["_trackEvent", "起盘模块", "起盘", "点击智能评测"]);
            }
            // 检验数据
            if(this.formData.birthday == '' || typeof(this.formData.birthday) == 'number'){
                this.$toast("请填写生日");
                return;
            }
            // 处理姓名:可以空名起盘，生成命名取为"未命名"
            this.formData.f_name = this.formData.f_name == '' ? "未命名" : this.formData.f_name;
            // 处理分组:
            this.formData.f_group = this.choosedGroup.id;
            this.formData.f_group = !this.formData.f_group || this.formData.f_group == '' ? 0 : this.formData.f_group;
            // 处理性别:
            this.formData.sex = this.formData.sex == '' ? 0 : this.formData.sex;
            // 处理早晚子时:
            this.formData.zwzs = 1;
            // 处理标签及备注信息
            this.formData.label = this.$store.state.label.selectedLabelId;
            this.formData.remark = this.$store.state.label.remarkStringData;

            console.log("起盘:::::", this.formData);
            
            var me = this;
            this.$store.state.collate.curStartCollateType = type;
            this.$store.dispatch('record/checkRecordListSameSiZhu', {
                formData: this.formData,
                cb: function() {
                    if(type == 'collate') {
                        me.$store.dispatch('collate/submitCollate', me.formData);
                    }else if(type == 'report') {
                        me.$store.dispatch('collate/submitReport', me.formData);
                    }
                }
            });
        },
        blurInputName() {
            // 输入完成之后处理页面滚动
            if(this.parentNode.name == 'EditDetail'){
                var detailDiv = document.getElementsByClassName('edit-detail-content')[0];
                if(detailDiv){
                    detailDiv.scrollIntoView();
                }
            }
        },
        changeName() {
            if(this.parentNode.name == 'EditDetail'){
                this.$store.dispatch('edit/updateEditDetail', 'name');
            }
        },
        changeZWZ(choosed) {
            this.choosedZWZ = choosed; this.choosedNZWZ = !choosed;
            this.personData.zwzs = choosed ? 1 : 0;
            if(this.parentNode.name == 'EditDetail'){
                this.$store.dispatch('edit/updateEditDetail', 'zwzs');
            }
        },
        changeNZWZ(choosed) {
            this.choosedZWZ = !choosed; this.choosedNZWZ = choosed;
            this.personData.zwzs = choosed ? 0 : 1;
            if(this.parentNode.name == 'EditDetail'){
                this.$store.dispatch('edit/updateEditDetail', 'zwzs');
            }
        }
    }
}
</script>